import React from 'react';

function TopBar({ title, subtitle, children }) {
  return (
    <div className="topbar">
      <div className="topbar__left">
        <h1 className="topbar__title">{title}</h1>
        {subtitle && <span className="topbar__subtitle">{subtitle}</span>}
      </div>
      {children && <div className="topbar__actions">{children}</div>}
    </div>
  );
}

export default TopBar;
